/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { ListeContainer, useListe } from '@mairistem/liste';

import ActeNaissanceListe from './ActeNaissanceListe';

interface ActeNaissanceListeContainerProps {
  /** Réduit la liste à la seule colonne du nom, pour la sidebar de la fiche. */
  sidebar?: boolean;
}

const ActeNaissanceListeContainer = ({
  sidebar,
}: ActeNaissanceListeContainerProps = {}) => {
  const [service] = useListe(
    '/api/administres/etat-civil/numerisation-actes/liste',
    { type_acte: 'naissance' },
  );

  return (
    <ListeContainer
      type="actes"
      contains="liste"
      service={service}
      perPage={20}
    >
      <ActeNaissanceListe sidebar={sidebar} />
    </ListeContainer>
  );
};

export default ActeNaissanceListeContainer;
